import { defineStore } from 'pinia';
export const response = defineStore('response', {
    state: () => ({
      msg: '', //信息
      code: 0, //状态码
      showTopUp: false, //显示充值弹窗
      showTopUpCount: 0, //显示充值弹窗版本
    }),
    actions: {
      setCode(code) {
        this.code = code;
      },
      setMsg(msg) {
        this.msg = msg;
      },
      setShowTopUp(showTopUp) {
        this.showTopUp = showTopUp;
        let count = this.showTopUpCount+1;
        console.log('showTopUpCount', count);
        this.showTopUpCount = count;
      },
      setAll(code, msg) {
        this.code = code;
        this.msg = msg;
      },
    },
  })